import {escapes} from "./helper";

const pureCode = (block: string):string =>
  `<pre class="language-none"><code class="language-none">${escapes(
    block
  )}</code></pre>`;
export default pureCode;
